exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Da5CE92-ViewUsersTable-module-users-table ._1ln_geS4-ViewUsersTable-module-td._3JZbiBDo-ViewUsersTable-module-users-table-td{border-color:#aaa;padding-left:15px;padding-right:15px}._2Da5CE92-ViewUsersTable-module-users-table ._1sHUGGrP-ViewUsersTable-module-th._1lcp4vSf-ViewUsersTable-module-users-table-th{border-color:#aaa}._2Da5CE92-ViewUsersTable-module-users-table ._3JZbiBDo-ViewUsersTable-module-users-table-td._3RM0OMmn-ViewUsersTable-module-wrap{white-space:normal}", ""]);

// exports
exports.locals = {
	"primary": "#067370",
	"users-table": "_2Da5CE92-ViewUsersTable-module-users-table",
	"usersTable": "_2Da5CE92-ViewUsersTable-module-users-table",
	"td": "_1ln_geS4-ViewUsersTable-module-td",
	"users-table-td": "_3JZbiBDo-ViewUsersTable-module-users-table-td",
	"usersTableTd": "_3JZbiBDo-ViewUsersTable-module-users-table-td",
	"th": "_1sHUGGrP-ViewUsersTable-module-th",
	"users-table-th": "_1lcp4vSf-ViewUsersTable-module-users-table-th",
	"usersTableTh": "_1lcp4vSf-ViewUsersTable-module-users-table-th",
	"wrap": "_3RM0OMmn-ViewUsersTable-module-wrap"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/pages/Admin/sections/Users/ViewUsers/ViewUsersTable/ViewUsersTable.module.scss
// module id = 1201
// module chunks = 0